import { createRouter, createWebHistory } from 'vue-router'
import LRSPurchase from '../components/LRSPurchase.vue'
import AdminLogin from '../components/AdminLogin.vue'
import AdminDashboard from '../components/AdminDashboard.vue'
import ChangePassword from '../components/ChangePassword.vue'
import TransactionsGrid from '../components/TransactionsGrid.vue'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: LRSPurchase
    },
    {
      path: '/admin/login',
      component: AdminLogin
    },
    {
      path: '/admin/dashboard',
      component: AdminDashboard,
      beforeEnter: (to, from, next) => {
        if (!localStorage.getItem('adminToken')) {
          next('/admin/login')
        } else {
          next()
        }
      }
    },
    {
      path: '/admin/change-password',
      component: ChangePassword
    },
    {
      path: '/admin/transactions',
      name: 'transactions',
      component: TransactionsGrid,
      meta: { requiresAuth: true }
    }
  ]
})

export default router 